/**
 * <ClassItem 
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React from 'react';
import classnames from 'classnames'
import ProfileBadge from 'components/UI/ProfileBadge'
import Loading from 'components/UI/Loading';
import locale from './locale.js';
import moment from 'moment';
import Pagination from 'react-js-pagination';

const LESSON_TIME_FORMAT = 'YYYY-MM-DD hh:mm:ss';
const DISPLAY_TIME_FORMAT = 'HH:mm';
const DISPLAY_DATE_FORMAT = 'YYYY-MM-DD';

class LessonList extends React.Component {

  constructor(props) {
    super(props);
    this.handleLessonScrolling = this.handleLessonScrolling.bind(this);
  }

  handleLessonScrolling(){
    const { loadMoreLessons, isloadingMoreLesson } = this.props;
    let bottomOffset = 400;
    if(this.lessonLoadingScroller && !isloadingMoreLesson && (this.lessonLoadingScroller.scrollTop >= this.lessonLoadingScroller.scrollHeight-bottomOffset)){
      loadMoreLessons();
    }
  }

  render() {
    const {
      loadingLessons,
      lessonList = [],
      onToggleLessonSelect,
      lessonIDSelected = [],
      cls,
      onPreviousStageSelect,
      onToggleCurrentPageLessons,
      pageSelectAllTracker,
      onPageChanged,
      pagination,
      selectAllLessonsInClass,
      isAllLessonsSelected
    } = this.props;
    const { teacherList, has_lesson } = cls;

    const profiles = teacherList.map((teacher)=>{
      return {
        name: teacher.stName,
      }
    });

    return (
      <div className='select-class-item'>
        <div className='selected-class-info'>
          <div className='previous-button' onClick={onPreviousStageSelect}>
            <i className='fa icon-left-open right-arrow'></i>
          </div>
          <div className='selected-class-wrapper'>
            <div className='class-title'>{cls.className}</div>
            <div className='class-detail'> 
              <div className='text-wrapper class-date'>{__('Date', 'class')}: {cls.earliest_date} - {cls.latest_date}</div>            
              <div className='text-wrapper class-student'>{__('Student: {number}', 'schedule', { number: cls.studentCount })}</div>    
              <div className='text-wrapper class-teacher'>
                <div>{__('Teacher', 'teacher')}:</div>               
                { teacherList.length === 0 && <span> {__('N/A', 'data')}</span> }
                { profiles.length > 0 && <span> <ProfileBadge profiles={profiles} /></span> }  
              </div>   
            </div>
          </div>
        </div>
        <div className='selection-wrapper'>
          <div className='selection-label'>
            <label className='control' onClick={(e)=>onToggleCurrentPageLessons(e)}>
              <input type='checkbox' disabled={!has_lesson} checked={pageSelectAllTracker[pagination.activePage-1]}/>
              <span className='checkmark'></span> 
            </label>
            <span className='label-text'>
              {__('Selected {selectedLessons}/{totalLessons} Lessons', locale, { selectedLessons: lessonIDSelected.length, totalLessons: pagination.totalItemsCount})}
            </span>
          </div>
          <button className='select-all-btn' disabled={!has_lesson} onClick={()=>selectAllLessonsInClass()}>
            {isAllLessonsSelected?__('Unselect All Lessons', locale): __('Select All Lessons', locale)}
          </button>
        </div>
        { loadingLessons == true && 
          <div className='loading-wrapper'>       
            <Loading zoom={0.7} /> 
          </div>
        }
        { loadingLessons == true && <div className='loadingMask'></div> }
        { !loadingLessons && lessonList.length> 0 &&
          <div className={classnames('select-lesson-wrapper', { lessonLoaded: loadingLessons !== true })}>
              {lessonList.map((lesson, key)=>{
                const { lesson_status, lesson_number, lesson_id, lesson_start_time, lesson_end_time,} = lesson;  
                const lessonSelected = lessonIDSelected.indexOf(lesson_id) > -1;
                const lessonDisabled = lesson_status == 1;
                
                return (
                  <div className={classnames('lessonItem', { lessonDisabled, lessonSelected })} key={key} onClick={()=>{
                      if (lessonDisabled != true) {
                        onToggleLessonSelect(lesson_id)()
                      }
                    }}>
                    <div className='lessonCheckbox'>
                      <label className='control'>
                        <input type='checkbox' disabled={lessonDisabled} checked={lessonSelected == true} />
                        <span className='checkmark'></span> 
                      </label>
                    </div>  
                    <div className='lessonNumber'>{__('Lesson {lesson_number}', locale, { lesson_number })}</div>
                    <div className='lessonDate'>{moment(lesson_start_time, LESSON_TIME_FORMAT).format(DISPLAY_DATE_FORMAT)}</div>
                    <div className='lessonTime'>
                      {moment(lesson_start_time, LESSON_TIME_FORMAT).format(DISPLAY_TIME_FORMAT)} - {moment(lesson_end_time, LESSON_TIME_FORMAT).format(DISPLAY_TIME_FORMAT)}
                    </div>
                  </div>
                )
              })}
          </div>
        }
        {
          lessonList.length === 0 && 
          <div className='noLessonText'>{__('No Lessons', locale)}</div>
        }
        <div className='pagination-wrapper'>
          <Pagination
            activePage={pagination.activePage}
            itemsCountPerPage={pagination.itemsPerPage}
            totalItemsCount={pagination.totalItemsCount}
            onChange={onPageChanged}
          />
        </div>
      </div>
    );
  }
}

export default LessonList;



// WEBPACK FOOTER //
// ./src/template/Modals/EnrollClass/LessonList.js